import WeightFilter from './weight-filter';

export default WeightFilter;
